/**
 * Menu da plataforma Marketing — os grupos e itens do protótipo "Snapfy Ads"
 * (Geral · Criar · Inteligência · Marca · Entrega), na mesma ordem.
 *
 * Item com `to` navega; item sem `to` ainda não tem tela nem backend e aparece
 * desabilitado com "Em breve" — cada um entra num PR próprio (um assunto por PR).
 */
export type MarketingNavItemId =
  | 'home'
  | 'imageAd'
  | 'videoAd'
  | 'batch'
  | 'competitors'
  | 'references'
  | 'brandDna'
  | 'products'
  | 'ads'
  | 'projects'
  | 'publishing';

export type MarketingIconName = 'home' | 'image' | 'video' | 'batch' | 'competitors' | 'references' | 'dna' | 'products' | 'ads' | 'projects' | 'publishing';

export interface MarketingNavItem {
  id: MarketingNavItemId;
  icon: MarketingIconName;
  /** Rota da tela; ausente = "Em breve". */
  to?: string;
}

export interface MarketingNavGroup {
  id: 'general' | 'create' | 'intelligence' | 'brand' | 'delivery';
  items: MarketingNavItem[];
}

export const MARKETING_NAV: MarketingNavGroup[] = [
  { id: 'general', items: [{ id: 'home', icon: 'home', to: '/marketing' }] },
  {
    id: 'create',
    items: [
      { id: 'imageAd', icon: 'image', to: '/marketing/anuncio-imagem' },
      { id: 'videoAd', icon: 'video' },
      { id: 'batch', icon: 'batch' },
    ],
  },
  {
    id: 'intelligence',
    items: [
      { id: 'competitors', icon: 'competitors' },
      { id: 'references', icon: 'references' },
    ],
  },
  {
    id: 'brand',
    items: [
      { id: 'brandDna', icon: 'dna', to: '/marketing/dna' },
      { id: 'products', icon: 'products', to: '/marketing/produtos' },
    ],
  },
  {
    id: 'delivery',
    items: [
      { id: 'ads', icon: 'ads', to: '/marketing/anuncios' },
      { id: 'projects', icon: 'projects' },
      { id: 'publishing', icon: 'publishing' },
    ],
  },
];

/**
 * Menu "O que você quer criar?" (atalho C). Opções com `to` reaproveitam
 * ferramentas que já existem, montadas dentro do segmento Marketing.
 */
export type CreateOptionId =
  | 'staticAd'
  | 'carousel'
  | 'adaptFormats'
  | 'ugc'
  | 'talkingHead'
  | 'animate'
  | 'recreate'
  | 'batch'
  | 'playground';

export interface CreateOption {
  id: CreateOptionId;
  to?: string;
}

export interface CreateGroup {
  id: 'image' | 'video' | 'reference' | 'scratch';
  options: CreateOption[];
}

export const CREATE_MENU: CreateGroup[] = [
  { id: 'image', options: [{ id: 'staticAd', to: '/marketing/anuncio-imagem' }, { id: 'carousel' }, { id: 'adaptFormats' }] },
  { id: 'video', options: [{ id: 'ugc' }, { id: 'talkingHead' }, { id: 'animate', to: '/marketing/animar-imagem' }] },
  { id: 'reference', options: [{ id: 'recreate' }, { id: 'batch' }] },
  { id: 'scratch', options: [{ id: 'playground', to: '/marketing/playground' }] },
];

export const isMarketingNavActive = (item: MarketingNavItem, pathname: string): boolean =>
  !!item.to && (item.to === '/marketing' ? pathname === '/marketing' || pathname === '/marketing/' : pathname.startsWith(item.to));
